import React from 'react';
import { useBrand } from '../contexts/BrandContext';

const BrandLogo = ({ className = '', size = 'md', dark = false }) => {
  const { brandName, primaryColor, logoUrl, fontFamily } = useBrand();

  const sizeClasses = {
    sm: { logo: 'h-8', text: 'text-lg', container: 'space-x-2' },
    md: { logo: 'h-10', text: 'text-2xl', container: 'space-x-3' },
    lg: { logo: 'h-16', text: 'text-4xl', container: 'space-x-4' },
    xl: { logo: 'h-20', text: 'text-5xl', container: 'space-x-4' }
  };

  const sizes = sizeClasses[size] || sizeClasses.md;

  return (
    <div className={`flex items-center ${sizes.container} ${className}`}>
      {logoUrl ? (
        <img src={logoUrl} alt="" className={`${sizes.logo} w-auto object-contain`} style={{ mixBlendMode: dark ? 'screen' : 'multiply' }} />
      ) : null}
      <span className={`${sizes.text} font-bold`} style={{ color: primaryColor, fontFamily: fontFamily || 'Inter' }}>
        {brandName}
      </span>
    </div>
  );
};

export default BrandLogo;
